(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 9094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ Center; }
/* harmony export */ });
/* unused harmony export _Center */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64761);
/* harmony import */ var _mantine_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97818);
/* harmony import */ var _mantine_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48427);
/* harmony import */ var _Box_Box_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7414);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const _Center = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => {
  const _a = (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_1__/* .useComponentDefaultProps */ .N4)("Center", {}, props), { inline, sx } = _a, others = __objRest(_a, ["inline", "sx"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Box_Box_js__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, __spreadValues({
    ref,
    sx: [
      {
        display: inline ? "inline-flex" : "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      ...(0,_mantine_utils__WEBPACK_IMPORTED_MODULE_3__/* .packSx */ .R)(sx)
    ]
  }, others));
});
_Center.displayName = "@mantine/core/Center";
const Center = (0,_mantine_utils__WEBPACK_IMPORTED_MODULE_4__/* .createPolymorphicComponent */ .F)(_Center);


//# sourceMappingURL=Center.js.map


/***/ }),

/***/ 39954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-did-update/use-did-update.js
var use_did_update = __webpack_require__(37048);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Image/ImageIcon.js


var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function ImageIcon(props) {
  return /* @__PURE__ */ react.createElement("svg", __spreadValues({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ react.createElement("path", {
    d: "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}


//# sourceMappingURL=ImageIcon.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Image/Image.styles.js


var Image_styles_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Image_styles_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Image_styles_hasOwnProp = Object.prototype.hasOwnProperty;
var Image_styles_propIsEnum = Object.prototype.propertyIsEnumerable;
var Image_styles_defNormalProp = (obj, key, value) => key in obj ? Image_styles_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Image_styles_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Image_styles_hasOwnProp.call(b, prop))
      Image_styles_defNormalProp(a, prop, b[prop]);
  if (Image_styles_getOwnPropSymbols)
    for (var prop of Image_styles_getOwnPropSymbols(b)) {
      if (Image_styles_propIsEnum.call(b, prop))
        Image_styles_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var useStyles = (0,create_styles/* createStyles */.k)((theme, { radius }) => ({
  root: {},
  imageWrapper: {
    position: "relative"
  },
  figure: {
    margin: 0
  },
  image: __spreadProps(Image_styles_spreadValues({}, theme.fn.fontStyles()), {
    display: "block",
    width: "100%",
    height: "100%",
    border: 0,
    borderRadius: theme.fn.size({ size: radius, sizes: theme.radius })
  }),
  caption: {
    color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
    marginTop: theme.spacing.xs
  },
  placeholder: __spreadProps(Image_styles_spreadValues({}, theme.fn.cover()), {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0],
    borderRadius: theme.fn.size({ size: radius, sizes: theme.radius })
  })
}));

/* harmony default export */ var Image_styles = (useStyles);
//# sourceMappingURL=Image.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Image/Image.js








var Image_defProp = Object.defineProperty;
var Image_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Image_hasOwnProp = Object.prototype.hasOwnProperty;
var Image_propIsEnum = Object.prototype.propertyIsEnumerable;
var Image_defNormalProp = (obj, key, value) => key in obj ? Image_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Image_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Image_hasOwnProp.call(b, prop))
      Image_defNormalProp(a, prop, b[prop]);
  if (Image_getOwnPropSymbols)
    for (var prop of Image_getOwnPropSymbols(b)) {
      if (Image_propIsEnum.call(b, prop))
        Image_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Image_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Image_getOwnPropSymbols)
    for (var prop of Image_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Image_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  fit: "cover",
  width: "100%",
  height: "auto",
  radius: 0
};
const Image = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Image", defaultProps, props), {
    className,
    alt,
    src,
    fit,
    width,
    height,
    radius,
    imageProps,
    withPlaceholder,
    placeholder,
    imageRef,
    classNames,
    styles,
    caption,
    unstyled,
    style
  } = _a, others = __objRest(_a, [
    "className",
    "alt",
    "src",
    "fit",
    "width",
    "height",
    "radius",
    "imageProps",
    "withPlaceholder",
    "placeholder",
    "imageRef",
    "classNames",
    "styles",
    "caption",
    "unstyled",
    "style"
  ]);
  const { classes, cx } = Image_styles({ radius }, { classNames, styles, unstyled, name: "Image" });
  const [error, setError] = (0,react.useState)(!src);
  const isPlaceholder = withPlaceholder && error;
  (0,use_did_update/* useDidUpdate */.l)(() => {
    setError(!src);
  }, [src]);
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, Image_spreadValues({
    className: cx(classes.root, className),
    ref,
    style: Image_spreadValues({ width }, style)
  }, others), /* @__PURE__ */ react.createElement("figure", {
    className: classes.figure
  }, /* @__PURE__ */ react.createElement("div", {
    className: classes.imageWrapper
  }, /* @__PURE__ */ react.createElement("img", Image_spreadValues({
    className: classes.image,
    src,
    alt,
    style: { objectFit: fit, width, height },
    ref: imageRef,
    onError: (event) => {
      setError(true);
      typeof (imageProps == null ? void 0 : imageProps.onError) === "function" && imageProps.onError(event);
    }
  }, imageProps)), isPlaceholder && /* @__PURE__ */ react.createElement("div", {
    className: classes.placeholder,
    title: alt
  }, placeholder || /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(ImageIcon, {
    style: { width: 40, height: 40 }
  })))), !!caption && /* @__PURE__ */ react.createElement(Text/* Text */.x, {
    component: "figcaption",
    size: "sm",
    align: "center",
    className: classes.caption
  }, caption)));
});
Image.displayName = "@mantine/core/Image";


//# sourceMappingURL=Image.js.map


/***/ }),

/***/ 77299:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.p = function BsChevronLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 16 16","fill":"currentColor"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M11.354 1.646a.5.5 0 010 .708L5.707 8l5.647 5.646a.5.5 0 01-.708.708l-6-6a.5.5 0 010-.708l6-6a.5.5 0 01.708 0z","clipRule":"evenodd"}}]})(props);
};


/***/ }),

/***/ 64666:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.f = function BsChevronRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 16 16","fill":"currentColor"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M4.646 1.646a.5.5 0 01.708 0l6 6a.5.5 0 010 .708l-6 6a.5.5 0 01-.708-.708L10.293 8 4.646 2.354a.5.5 0 010-.708z","clipRule":"evenodd"}}]})(props);
};


/***/ }),

/***/ 97432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.g = function FaCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"}}]})(props);
};


/***/ }),

/***/ 44164:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.Q = function FiCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"circle","attr":{"cx":"12","cy":"12","r":"10"}}]})(props);
};


/***/ }),

/***/ 43516:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.X = function FiCreditCard (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"rect","attr":{"x":"1","y":"4","width":"22","height":"16","rx":"2","ry":"2"}},{"tag":"line","attr":{"x1":"1","y1":"10","x2":"23","y2":"10"}}]})(props);
};


/***/ }),

/***/ 43916:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(37629);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gc": function() { return /* binding */ HOME_BANNER_OPTIONS; },
  "kp": function() { return /* binding */ useFetchBanners; }
});

// UNUSED EXPORTS: DEFAULT_BANNER_OPTIONS, fetchBanners

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./apis/fetch.js
var fetch = __webpack_require__(36203);
// EXTERNAL MODULE: ./utils/lodash.js
var lodash = __webpack_require__(59926);
;// CONCATENATED MODULE: ./apis/queryKeys/bannersKeys.js


var sort = {
    date_created: -1
};
var bannersKeys = {
    all: [
        {
            scope: "ecombanners",
            limit: 100,
            sort: sort
        }
    ],
    count: function(options) {
        return [
            (0,_object_spread/* default */.Z)({
                scope: "ecombanners",
                type: "count"
            }, (0,lodash/* flattenObj */.nO)(options || {})), 
        ];
    },
    list: function(vi_tri) {
        return [
            {
                scope: "ecombanners",
                type: "list",
                vi_tri: vi_tri
            }, 
        ];
    },
    detail: function(_id) {
        return [
            {
                scope: "ecombanners",
                type: "detail",
                _id: _id
            }
        ];
    }
};
/* harmony default export */ var queryKeys_bannersKeys = (bannersKeys);

;// CONCATENATED MODULE: ./apis/queryFunctions/banner.js








var DEFAULT_STALE_TIME = 60000 * 5; // 5min
var DEFAULT_BANNER_OPTIONS = {
    sort: {
        stt: 1
    },
    limit: 5,
    condition: {
        status: true,
        shared: true
    }
};
var HOME_BANNER_OPTIONS = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, DEFAULT_BANNER_OPTIONS), {
    condition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, DEFAULT_BANNER_OPTIONS.condition), {
        vi_tri: "home-top-sliders-cafe"
    })
});
var fetchBanners = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var options, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    return _ctx.abrupt("return", (0,fetch/* asyncGetList */.NE)({
                        collection_name: "ecombanners",
                        options: options
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchBanners() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchBanners = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var locale = (0,router.useRouter)().locale;
    var mergeOptions = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
        condition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (options === null || options === void 0 ? void 0 : options.condition) || {}), {
            ngon_ngu: locale
        })
    });
    return (0,useQuery/* useQuery */.a)(queryKeys_bannersKeys.list(mergeOptions), function() {
        return fetchBanners(mergeOptions);
    }, {
        enabled: !!(options === null || options === void 0 ? void 0 : (ref = options.condition) === null || ref === void 0 ? void 0 : ref.vi_tri),
        staleTime: DEFAULT_STALE_TIME,
        onSuccess: function(banners) {
            banners.map(function(banner) {
                queryClient.setQueriesData(queryKeys_bannersKeys.detail(banner === null || banner === void 0 ? void 0 : banner._id), banner);
            });
        }
    });
};


/***/ }),

/***/ 54522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useMenu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/* harmony import */ var _utils_slugifyString__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91957);



var useMenu = function(data) {
    // console.log(data);
    var menu = [];
    var highlights = [];
    var menuParent = data === null || data === void 0 ? void 0 : data.filter(function(item) {
        return item.highlight;
    });
    if (!(data === null || data === void 0 ? void 0 : data.length)) return {
        menu: menu,
        menuParent: menuParent
    };
    var menuChildren = data.filter(function(item) {
        return item.danh_muc_me !== "VIETTHIEN" && item.danh_muc_me !== "" && !item.highlight;
    });
    menuParent.map(function(item) {
        return highlights.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, item), {
            title: item.ten_danh_muc,
            href: "/mua-hang/".concat(item.slug, "?cat=").concat(item.ma_danh_muc, "|").concat(menuChildren.filter(function(cat) {
                return cat.danh_muc_me === item.ma_danh_muc;
            }).map(function(el) {
                return el.ma_danh_muc;
            }).join("|"), "&page=1"),
            subMenu: {
                subMenuLeft: [],
                subMenuRight: []
            }
        }));
    });
    menuChildren.map(function(item) {
        var ten_danh_muc_me = item.ten_danh_muc_me;
        var positionParent = menu.map(function(e) {
            return e.title;
        }).indexOf(ten_danh_muc_me);
        if (positionParent >= 0) {
            menu[positionParent].subMenu.subMenuLeft.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, item), {
                title: item.ten_danh_muc,
                href: "/mua-hang/".concat((0,_utils_slugifyString__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(item.ten_danh_muc_me), "?cat=").concat(item.ma_danh_muc, "&page=1")
            }));
            if (item.logo || item.image) {
                menu[positionParent].subMenu.subMenuRight.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, item), {
                    title: item.ten_danh_muc,
                    href: "/mua-hang/".concat((0,_utils_slugifyString__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(item.ten_danh_muc_me), "?cat=").concat(item.ma_danh_muc, "&page=1"),
                    image: item.logo || item.image
                }));
            }
        }
    });
    // menu.unshift({
    //   title: "Sản phẩm mới",
    //   href: `/collections/san-pham-moi?cat=${menuChildren
    //     .map((el) => el.ma_danh_muc)
    //     .join("|")}&sort=newest`,
    // });
    // menu.push(
    //   {
    //     title: "Khuyến mãi",
    //     href: `/collections/san-pham-moi?cat=${menuChildren
    //       .map((el) => el.ma_danh_muc)
    //       .join("|")}&filterBy=promotion`,
    //   },
    //   {
    //     title: "Liên hệ",
    //     href: "/lien-he",
    //   }
    // );
    return {
        menu: menu,
        menuParent: menuParent,
        highlights: highlights
    };
};


/***/ }),

/***/ 11775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AB": function() { return /* binding */ useFetchNewsArticles; },
/* harmony export */   "G9": function() { return /* binding */ useFetchNewsArticle; },
/* harmony export */   "aC": function() { return /* binding */ useFetchNewsArticlesCount; },
/* harmony export */   "cW": function() { return /* binding */ DEFAULT_FETCHING_NEWS_OPTIONS; }
/* harmony export */ });
/* unused harmony exports fetchNewsArticle, fetchNewsArticles, fetchNewsArticlesCount */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67848);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85945);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36203);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76296);







var DEFAULT_STALE_TIME = 1000 * 60 * 30; // 30 min
var DEFAULT_FETCHING_NEWS_OPTIONS = {
    limit: 8,
    page: 1,
    condition: {
        ngon_ngu: "vi",
        loai_tin_tuc: "Tin tức c\xe0 ph\xea"
    }
};
var fetchNewsArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetItem */ .p9)({
                        collection_name: "news",
                        options: {
                            shared: true,
                            condition: {
                                slug: slug
                            }
                        }
                    });
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticle(slug) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticle = function(slug) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.detail */ .w3.detail(slug), function() {
        return fetchNewsArticle(slug);
    }, {
        // staleTime: DEFAULT_STALE_TIME,
        enabled: !!slug
    });
};
/* -------------------------------------------------------------------------- */ var fetchNewsArticles = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var options, _args = arguments;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        collection_name: "news",
                        options: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            page: 1,
                            limit: 8,
                            sort: {
                                stt: 1,
                                date_created: -1
                            }
                        }, options), {
                            condition: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                                isnews: true,
                                ngon_ngu: "vi",
                                shared: true
                            }, (options === null || options === void 0 ? void 0 : options.condition) || {})
                        })
                    });
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticles() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticles = function(options) {
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQueryClient */ .NL)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.list */ .w3.list(options), function() {
        return fetchNewsArticles(options);
    }, {
        enabled: !!options,
        staleTime: DEFAULT_STALE_TIME,
        onSuccess: function(newsArticles) {
            newsArticles.map(function(newsArticle) {
                queryClient.setQueriesData(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.detail */ .w3.detail(newsArticle === null || newsArticle === void 0 ? void 0 : newsArticle.slug), newsArticle);
            });
        }
    });
};
/* -------------------------------------------------------------------------- */ var fetchNewsArticlesCount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var options, locale, data, _args = arguments;
        return _root_webs_cafevietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {}, locale = _args.length > 1 ? _args[1] : void 0;
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        collection_name: "news",
                        options: {
                            count: true,
                            condition: {
                                ngon_ngu: locale,
                                isnews: true,
                                loai_tin_tuc: "Tin tức c\xe0 ph\xea"
                            }
                        }
                    });
                case 3:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", (data === null || data === void 0 ? void 0 : data.rows_number) || 0);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticlesCount() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticlesCount = function(options, locale) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.count */ .w3.count((options === null || options === void 0 ? void 0 : options.condition) || {}), function() {
        return fetchNewsArticlesCount(options, locale);
    }, {
        enabled: !!options,
        staleTime: DEFAULT_STALE_TIME
    });
};


/***/ }),

/***/ 34964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22312);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56817);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21017);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38623);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66137);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95117);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);







var useStyles = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .createStyles */ .k)(function() {
    return {
        imageWrapper: {
            width: "100%",
            aspectRatio: "1.5",
            position: "relative"
        }
    };
});
function NewCard(param) {
    var item = param.item, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var classes = useStyles().classes;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Card */ .Z, {
        shadow: "sm",
        p: 0,
        radius: "sm",
        sx: {
            height: "100%",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                scroll: false,
                href: "/tin-tuc/".concat(item === null || item === void 0 ? void 0 : item.slug) || 0,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                            visible: isLoading,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Card.Section */ .Z.Section, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes.imageWrapper,
                                    children: !isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                                            src: item === null || item === void 0 ? void 0 : item.picture,
                                            size: "s"
                                        }),
                                        alt: "Norway",
                                        layout: "fill",
                                        objectFit: "contain"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Group */ .Z, {
                            p: "md",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                                    visible: isLoading,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                        style: {
                                            letterSpacing: 1
                                        },
                                        transform: "uppercase",
                                        size: "sm",
                                        lineClamp: 2,
                                        weight: "500",
                                        children: (item === null || item === void 0 ? void 0 : item.title) || "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Skeleton */ .O, {
                                    visible: isLoading,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                        size: "xs",
                                        children: new Date(item === null || item === void 0 ? void 0 : item.date_updated).toLocaleDateString(locale, {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            (item === null || item === void 0 ? void 0 : item.thong_tin_km) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/khuyen_mai.png",
                style: {
                    width: 64,
                    top: -10,
                    right: -10,
                    position: "absolute"
                }
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (NewCard);


/***/ }),

/***/ 99476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7414);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19236);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* eslint-disable jsx-a11y/anchor-is-valid */ 




function HomeTitle(param) {
    var children = param.children, _href = param.href, href = _href === void 0 ? "#" : _href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
        sx: function(theme) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                margin: "70px 0 20px"
            }, theme.fn.smallerThan("md"), {
                margin: "30px 15px"
            });
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Title */ .D, {
                    order: 2,
                    size: "h2",
                    align: "center",
                    w: "100#",
                    sx: function(theme) {
                        return {
                            transition: "0.3s",
                            color: theme.colors.second[3],
                            "&:hover": {
                                color: theme.colors.second[3]
                            }
                        };
                    },
                    children: children
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (HomeTitle);


/***/ }),

/***/ 15556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BestSellers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./apis/queryFunctions/productFunctions.js
var productFunctions = __webpack_require__(30007);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fi/FiChevronLeft.js
var FiChevronLeft = __webpack_require__(2335);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fi/FiChevronRight.js
var FiChevronRight = __webpack_require__(99789);
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/embla-carousel-react.esm.js + 1 modules
var embla_carousel_react_esm = __webpack_require__(57434);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/ProductCard/index.js + 13 modules
var ProductCard = __webpack_require__(19812);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./common/Typography/HomeTitle.js
var HomeTitle = __webpack_require__(99476);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./common/Typography/TextShowMore.js




var useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        text: {
            // lineHeight: 30,
            position: "relative",
            transition: ".3s",
            color: theme.colors.second[2],
            cursor: "pointer",
            "&:before": {
                content: "''",
                height: "2px",
                backgroundColor: "currentColor",
                opacity: ".3",
                transition: "all .3s",
                position: "absolute",
                bottom: 0,
                left: "20%",
                width: "60%"
            },
            "&:hover": {
                color: "#2f2415",
                "&:before": {
                    backgroundColor: "#2f2415",
                    transform: "scale(160%, 100%)"
                }
            }
        }
    };
});
function TextShowMore(param) {
    var children = param.children, href = param.href;
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href || "#",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                size: "sm",
                className: classes.text,
                transform: "uppercase",
                children: children
            })
        })
    });
}
/* harmony default export */ var Typography_TextShowMore = (TextShowMore);

;// CONCATENATED MODULE: ./common/Typography/HomeRow.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: ",
        ";\n  align-items: center;\n\n  @media (max-width: 576px) {\n    flex-direction: column;\n    margin-bottom: 8px;\n  }\n  margin: 30px 0;\n  @media (max-width: 576px) {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject(), function(props) {
    return props.hrefRight ? "space-between" : "center";
});
function HomeRow(param) {
    var labelLeft = param.labelLeft, labelRight = param.labelRight, hrefRight = param.hrefRight, hrefLeft = param.hrefLeft, _hasDecorate = param.hasDecorate, hasDecorate = _hasDecorate === void 0 ? false : _hasDecorate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        my: "md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            hrefRight: hrefRight,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTitle/* default */.Z, {
                    href: hrefLeft || "#",
                    hasDecorate: hasDecorate,
                    children: labelLeft
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_TextShowMore, {
                    href: hrefRight,
                    children: labelRight
                })
            ]
        })
    });
}
/* harmony default export */ var Typography_HomeRow = (HomeRow);

;// CONCATENATED MODULE: ./common/components/BestSellers.js










function BestSellers(param) {
    var labelLeft = param.labelLeft, labelRight = param.labelRight, hrefLeft = param.hrefLeft, title = param.title, href = param.href, ma_danh_muc_cty = param.ma_danh_muc_cty, except = param.except;
    var ref = (0,productFunctions/* useFetchHomePageProducts */.lS)({
        ma_danh_muc_cty: ma_danh_muc_cty
    }), products = ref.data, isLoading = ref.isLoading;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,embla_carousel_react_esm/* default */.Z)({
        loop: true,
        align: "start",
        dragFree: true
    }), 2), sliderRef = ref1[0], sliderAPI = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), prevBtnEnabled = ref2[0], setPrevBtnEnabled = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), nextBtnEnabled = ref3[0], setNextBtnEnabled = ref3[1];
    var onSelect = react.useCallback(function() {
        if (!sliderAPI) return;
        setPrevBtnEnabled(sliderAPI.canScrollPrev());
        setNextBtnEnabled(sliderAPI.canScrollNext());
    }, [
        sliderAPI
    ]);
    react.useEffect(function() {
        if (!sliderAPI) return;
        sliderAPI.reInit();
    }, [
        sliderAPI
    ]);
    react.useEffect(function() {
        if (!sliderAPI || !onSelect) return;
        onSelect();
        sliderAPI.on("select", onSelect);
    }, [
        sliderAPI,
        onSelect
    ]);
    var scrollPrev = react.useCallback(function() {
        if (sliderAPI) sliderAPI.scrollPrev();
    }, [
        sliderAPI
    ]);
    var scrollNext = react.useCallback(function() {
        if (sliderAPI) sliderAPI.scrollNext();
    }, [
        sliderAPI
    ]);
    return !!(products === null || products === void 0 ? void 0 : products.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        py: 20,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_HomeRow, {
                labelLeft: title,
                hrefLeft: href
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bestsellers-list",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bestsellers-list__viewport",
                        ref: sliderRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bestsellers-list__container",
                            children: (isLoading ? [
                                {},
                                {},
                                {},
                                {},
                                {},
                                {}
                            ] : products).filter(function(el) {
                                return el.ma_vt !== except;
                            }).map(function(product) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bestsellers-list__slide",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                                        product: product,
                                        isLoading: isLoading
                                    })
                                }, product._id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "bestsellers-list__button bestsellers-list__prev",
                        onClick: scrollPrev,
                        type: "button",
                        disabled: !prevBtnEnabled,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FiChevronLeft/* FiChevronLeft */.Y, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "bestsellers-list__button bestsellers-list__next",
                        onClick: scrollNext,
                        type: "button",
                        disabled: !nextBtnEnabled,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FiChevronRight/* FiChevronRight */.T, {})
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 51623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);


function DefaultSEO(param) {
    var seo = param.seo;
    if (!seo) return null;
    var images = [];
    if (seo.picture1) {
        images.push({
            url: "".concat("https://api.flexzen.app").concat(seo.picture1, "?access_token=flex.public.token&trustkey=APP.FKJSHHHH908KJF"),
            width: 1200,
            height: 630,
            alt: "Zemor logo",
            type: "image/*"
        });
    }
    if (seo.picture2) {
        images.push({
            url: "".concat("https://api.flexzen.app").concat(seo.picture2, "?access_token=flex.public.token&trustkey=APP.FKJSHHHH908KJF"),
            width: 1200,
            height: 1200,
            alt: "Zemor logo",
            type: "image/*"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: seo.title || "ZeMor Coffee",
        description: seo.description,
        openGraph: {
            url: "https://zemor.vn",
            title: seo.title,
            description: seo.description,
            images: images,
            site_name: "ZeMor Coffee"
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (DefaultSEO);


/***/ }),

/***/ 95101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ PrevArrow; },
/* harmony export */   "g": function() { return /* binding */ NextArrow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16829);
/* harmony import */ var _react_icons_all_files_bs_BsChevronLeft__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77299);
/* harmony import */ var _react_icons_all_files_bs_BsChevronRight__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64666);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: ",
        ";\n  transform: translateY(-40%);\n  z-index: 99;\n\n  & svg {\n    cursor: pointer;\n    fill: white;\n    width: 32px;\n    height: 56px;\n    /* border-radius: 30px; */\n    background-color: rgba(0, 0, 0, 0.2);\n    padding: 0;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.4);\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject(), function(props) {
    return props.slider ? "50%" : "150px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.left) ? "left: 0;" : "right: 0;";
}, function(props) {
    return !(props === null || props === void 0 ? void 0 : props.slider) && ((props === null || props === void 0 ? void 0 : props.left) ? "transform: translate(-100%, -40%);" : "transform: translate(100%, -40%);");
});
function NextArrow(param) {
    var onClick = param.onClick, _slider = param.slider, slider = _slider === void 0 ? false : _slider;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        right: true,
        slider: slider,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_react_icons_all_files_bs_BsChevronRight__WEBPACK_IMPORTED_MODULE_4__/* .BsChevronRight */ .f, {
            onClick: onClick
        })
    });
}
function PrevArrow(param) {
    var onClick = param.onClick, _slider = param.slider, slider = _slider === void 0 ? false : _slider;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        left: true,
        slider: slider,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_react_icons_all_files_bs_BsChevronLeft__WEBPACK_IMPORTED_MODULE_5__/* .BsChevronLeft */ .p, {
            onClick: onClick
        })
    });
}


/***/ }),

/***/ 37629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./apis/queryFunctions/categoryFunctions.js
var categoryFunctions = __webpack_require__(46233);
// EXTERNAL MODULE: ./apis/queryFunctions/ecompagesFunctions.js
var ecompagesFunctions = __webpack_require__(4088);
// EXTERNAL MODULE: ./common/Layout/Container/Container.js
var Container = __webpack_require__(6559);
// EXTERNAL MODULE: ./common/components/DefaultSEO.js
var DefaultSEO = __webpack_require__(51623);
// EXTERNAL MODULE: ./utils/appendImageUrlFromAPI.js
var appendImageUrlFromAPI = __webpack_require__(22312);
// EXTERNAL MODULE: ./utils/sanitizeDOMData.js + 1 modules
var sanitizeDOMData = __webpack_require__(2559);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(62679);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./common/components/HomeAbout.js








function HomeAbout() {
    var ref;
    var locale = (0,router.useRouter)().locale;
    var data = (0,ecompagesFunctions/* useFetchEcompage */.VM)("du-lieu-chung-cafe", locale).data;
    var info = (data === null || data === void 0 ? void 0 : (ref = data.add_on_data) === null || ref === void 0 ? void 0 : ref[1]) || {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        component: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                    xs: 12,
                    md: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            align: "justify",
                            children: (0,sanitizeDOMData/* default */.Z)(info === null || info === void 0 ? void 0 : info.content)
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                    xs: 12,
                    md: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        sx: {
                            position: "relative",
                            width: "100%",
                            aspectRatio: (info === null || info === void 0 ? void 0 : info.content_2) || "1"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (0,appendImageUrlFromAPI/* default */.Z)({
                                src: info === null || info === void 0 ? void 0 : info.picture,
                                size: "l"
                            }),
                            layout: "fill"
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_HomeAbout = (HomeAbout);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./apis/queryFunctions/banner.js + 1 modules
var banner = __webpack_require__(88517);
// EXTERNAL MODULE: ./utils/slugifyString.js
var slugifyString = __webpack_require__(91957);
;// CONCATENATED MODULE: ./utils/getHrefLinkOfBanner.js

function getCategoryHref(categorySlug) {
    var href;
    if (!categorySlug) return "";
    if ((categorySlug === null || categorySlug === void 0 ? void 0 : categorySlug.toLowerCase()) === "viet-thien") {
        href = "/mua-hang/viet-thien?cat=ZF01.01|ZF01.02|ZF01.03|ZF01.04|ZF01.05|ZF02.01|ZF02.02|ZF03.01&sort=newest";
    }
    if ((categorySlug === null || categorySlug === void 0 ? void 0 : categorySlug.toLowerCase()) === "tra-bac") {
        href = "/mua-hang/tra-bac?cat=TRABAC&page=1";
    }
    if ((categorySlug === null || categorySlug === void 0 ? void 0 : categorySlug.toLowerCase()) === "tra-lai") {
        href = "/mua-hang/tra-lai?cat=TRALAI&page=1";
    }
    if ((categorySlug === null || categorySlug === void 0 ? void 0 : categorySlug.toLowerCase()) === "tra-moc-cau") {
        href = "/mua-hang/tra-moc-cau?cat=TRAMOCCAU&page=1";
    }
    if ((categorySlug === null || categorySlug === void 0 ? void 0 : categorySlug.toLowerCase()) === "tra-o-long") {
        href = "/mua-hang/tra-o-long?cat=TRAOLONG&page=1";
    }
    if ((categorySlug === null || categorySlug === void 0 ? void 0 : categorySlug.toLowerCase()) === "tra-sam-dua") {
        href = "/mua-hang/tra-sam-dua?cat=TRASAMDUA&page=1";
    }
    if ((categorySlug === null || categorySlug === void 0 ? void 0 : categorySlug.toLowerCase()) === "tra-tui-loc") {
        href = "/mua-hang/tra-tui-loc?cat=TRATUILOC&page=1";
    }
    return href;
}
function getProductHref(maVt, tenVt) {
    if (!maVt) return "";
    var slug = (0,slugifyString/* default */.Z)(tenVt);
    return "/products/".concat(slug, "-").concat(tenVt);
}
function getHrefLinkOfBanner(item) {
    var href = "";
    if (item === null || item === void 0 ? void 0 : item.link_to_page) href = item === null || item === void 0 ? void 0 : item.link_to_page;
    if (item === null || item === void 0 ? void 0 : item.link_to_product) href = getProductHref(item.link_to_product, item.link_to_product_title);
    if (item === null || item === void 0 ? void 0 : item.link_to_category) href = getCategoryHref(item.link_to_category);
    return href;
}

// EXTERNAL MODULE: ./node_modules/@ant-design/react-slick/es/index.js + 22 modules
var es = __webpack_require__(16530);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(38623);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./common/components/SliderArrows.js
var SliderArrows = __webpack_require__(95101);
;// CONCATENATED MODULE: ./common/components/HomeBanner.js












var useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        container: {
            width: "100%",
            maxHeight: "calc(100vh - 100px)",
            aspectRatio: "2.75",
            position: "relative"
        },
        sliderItem: {
            width: "100%",
            // maxHeight: "calc(100vh - 100px)",
            objectFit: "cover",
            height: "calc(100vh - 100px)",
            position: "relative",
            "@media (max-width: 36em)": {
                height: "calc(100vw / 2.2)",
                aspectRatio: "2.2"
            }
        },
        dotsClass: {
            position: "absolute",
            bottom: "10px",
            width: "100%",
            listStyle: "none",
            textAlign: "center",
            padding: 0,
            margin: 0,
            // "& li button:before": {
            //   fontSize: "10px !important",
            // },
            // "& li.slick-active button:before": {
            //   color: "#EBBC1D",
            // },
            "& li": {
                position: "relative",
                display: "inline-block",
                width: "20px",
                height: "20px",
                margin: "0 5px",
                padding: "0",
                cursor: "pointer"
            },
            "& li button": {
                fontSize: 0,
                lineHeight: 0,
                display: "block",
                width: "20px",
                height: "20px",
                padding: "5px",
                cursor: "pointer",
                color: "transparent",
                border: 0,
                outline: "none",
                background: "transparent"
            },
            "& li button:after": {
                // content: "'⚫'",
                fontFamily: "slick",
                fontSize: "10px",
                lineHeight: "20px",
                position: "absolute",
                top: 0,
                left: 0,
                width: "20px",
                height: "20px",
                content: "'•'",
                textAlign: "center",
                opacity: 0.25,
                color: theme.colors.second[0]
            },
            "& li.slick-active button:after": {
                opacity: ".75",
                color: "#EBBC1D"
            }
        }
    };
});
function HomeBanner() {
    var classes = useStyles().classes;
    // let dragging = false;
    var ref = (0,banner/* useFetchBanners */.kp)(banner/* HOME_BANNER_OPTIONS */.gc), sliders = ref.data;
    var settings = {
        dots: true,
        // infinite: true,
        initialSlide: 0,
        // speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        // appendDots: (dots) => <ul className={classes.dotsClass}>{dots}</ul>,
        dotsClass: classes.dotsClass,
        arrows: true,
        swipeToSlide: true,
        draggable: true,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderArrows/* NextArrow */.g, {
            slider: true
        }),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderArrows/* PrevArrow */.$, {
            slider: true
        }),
        useTransform: false
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
        visible: !sliders || sliders.length === 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.container,
            id: "sliders",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                children: sliders && sliders.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: getHrefLinkOfBanner(item),
                        scroll: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.sliderItem,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,appendImageUrlFromAPI/* default */.Z)({
                                            src: item.hinh_anh,
                                            size: "xl"
                                        }),
                                        alt: item.ten_banner,
                                        className: classes.sliderItem,
                                        quality: 100,
                                        loading: "lazy"
                                    })
                                })
                            })
                        })
                    }, item._id);
                })
            }))
        })
    });
};

// EXTERNAL MODULE: ./hooks/useTrans.js + 2 modules
var useTrans = __webpack_require__(26679);
// EXTERNAL MODULE: ./common/Typography/HomeTitle.js
var HomeTitle = __webpack_require__(99476);
;// CONCATENATED MODULE: ./common/components/HomeLiked.js










function HomeLiked() {
    var data = (0,categoryFunctions/* useFetchCategories */.rj)({
        condition: {}
    }).data;
    //limit 4 item homelike
    if (data && (data === null || data === void 0 ? void 0 : data.length) > 4) {
        data.splice(4, data.length - 4);
    }
    var trans = (0,useTrans/* default */.Z)();
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        component: "section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTitle/* default */.Z, {
                children: trans === null || trans === void 0 ? void 0 : trans.homeLiked.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                component: "section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                    gutter: 30,
                    justify: "center",
                    children: Boolean(data) && data.map(function(item, index) {
                        // eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                            xs: 6,
                            sm: 6,
                            sx: {
                                width: "100%",
                                cursor: "pointer",
                                transition: "1s"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/danh-muc-san-pham/".concat(item === null || item === void 0 ? void 0 : item.slug, "?sort=all"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                    sx: {
                                        position: "relative",
                                        aspectRatio: "1.5",
                                        width: "100%",
                                        // borderRadius: 8,
                                        borderTopLeftRadius: 40,
                                        borderBottomRightRadius: 144,
                                        overflow: "hidden",
                                        // height: 526,
                                        // backgroundColor: "#00723B",
                                        "&:hover": {
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (0,appendImageUrlFromAPI/* default */.Z)({
                                                src: item === null || item === void 0 ? void 0 : item.logo
                                            }),
                                            layout: "fill",
                                            objectFit: "cover"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                            sx: {
                                                position: "relative",
                                                aspectRatio: "1.5",
                                                width: "100%",
                                                borderRadius: 8,
                                                overflow: "hidden",
                                                transition: "1s",
                                                "&:hover": {
                                                    backgroundColor: "#00723B",
                                                    opacity: 0.5
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                            p: 8,
                                            sx: function(theme) {
                                                return {
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    width: "100%",
                                                    height: "100%",
                                                    transform: "translate(-50%, -50%)",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    display: "flex",
                                                    flexDirection: "column"
                                                };
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                    sx: function(theme) {
                                                        return {
                                                            width: "65%",
                                                            height: "35%",
                                                            display: "flex",
                                                            alignItems: "flex-end"
                                                        };
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                        sx: function(theme) {
                                                            return {
                                                                width: "100%",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                backgroundImage: theme.fn.radialGradient("#491f08 ", "#73300d 50%", "transparent"),
                                                                padding: "0.5rem 0"
                                                            };
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                            size: "1.5rem",
                                                            sx: function(theme) {
                                                                return {
                                                                    "@media (max-width: 48em)": {
                                                                        fontSize: "1.2rem"
                                                                    },
                                                                    opacity: 0.8,
                                                                    width: "100%"
                                                                };
                                                            },
                                                            align: "center",
                                                            color: "#fff",
                                                            weight: "bold",
                                                            children: locale === "vi" ? item === null || item === void 0 ? void 0 : item.ten_danh_muc : item === null || item === void 0 ? void 0 : item.ten_danh_muc_eng
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                    sx: function(theme) {
                                                        return {
                                                            height: "65%",
                                                            width: "100%",
                                                            justifyContent: "center",
                                                            display: "flex"
                                                        };
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        size: 16,
                                                        sx: {
                                                            width: "80%",
                                                            "@media (max-width: 50em)": {
                                                                fontSize: "0.8rem"
                                                            },
                                                            textShadow: "0 0 5px #000"
                                                        },
                                                        // lineClamp={4}
                                                        align: "center",
                                                        color: "#fff",
                                                        weight: "bold",
                                                        children: locale === "vi" ? item === null || item === void 0 ? void 0 : item.mo_ta_ngan : item === null || item === void 0 ? void 0 : item.mo_ta_ngan_eng
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, index);
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./apis/queryFunctions/news.js
var queryFunctions_news = __webpack_require__(11775);
// EXTERNAL MODULE: ./common/NewCard/index.js
var NewCard = __webpack_require__(34964);
;// CONCATENATED MODULE: ./common/components/HomeNews.js
/* eslint-disable react/no-array-index-key */ /* eslint-disable no-underscore-dangle */ 










function HomeNews() {
    var trans = (0,useTrans/* default */.Z)();
    var locale = (0,router.useRouter)().locale;
    var ref = (0,queryFunctions_news/* useFetchNewsArticles */.AB)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryFunctions_news/* DEFAULT_FETCHING_NEWS_OPTIONS */.cW), {
        condition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryFunctions_news/* DEFAULT_FETCHING_NEWS_OPTIONS.condition */.cW.condition), {
            ngon_ngu: locale
        })
    })), news = ref.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTitle/* default */.Z, {
                        href: "/tin-tuc",
                        children: trans.homeNews.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                        children: news ? news.slice(0, 4).map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                xs: 12,
                                sm: 6,
                                lg: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewCard/* default */.Z, {
                                    item: item
                                })
                            }, item._id);
                        }) : Array(4).fill(undefined).map(function(item, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                xs: 12,
                                sm: 6,
                                lg: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewCard/* default */.Z, {
                                    item: item,
                                    isLoading: true
                                })
                            }, i);
                        })
                    })
                ]
            })
        })
    });
}; // const HomeNews = () => {
 // };
 // export default HomeNews;

;// CONCATENATED MODULE: ./common/components/HomePromotion.js









function HomePromotion() {
    var ref;
    var trans = (0,useTrans/* default */.Z)();
    var locale = (0,router.useRouter)().locale;
    var data = (0,ecompagesFunctions/* useFetchEcompage */.VM)("du-lieu-chung-cafe", locale).data;
    var info = (data === null || data === void 0 ? void 0 : (ref = data.add_on_data) === null || ref === void 0 ? void 0 : ref[2]) || {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        component: "section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTitle/* default */.Z, {
                children: trans === null || trans === void 0 ? void 0 : trans.homePromotion.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                component: "section",
                sx: {
                    position: "relative",
                    width: "100%",
                    aspectRatio: "3",
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: (0,appendImageUrlFromAPI/* default */.Z)({
                        src: info === null || info === void 0 ? void 0 : info.picture
                    }),
                    layout: "fill",
                    objectFit: "cover"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-media-query/use-media-query.js
var use_media_query = __webpack_require__(34065);
;// CONCATENATED MODULE: ./common/components/Slogan.js










function Slogan() {
    var ref, ref1;
    var locale = (0,router.useRouter)().locale;
    var data = (0,ecompagesFunctions/* useFetchEcompage */.VM)("du-lieu-chung-cafe", locale).data;
    var slogan = (data === null || data === void 0 ? void 0 : (ref = data.add_on_data) === null || ref === void 0 ? void 0 : ref[0]) || {};
    var slogan2 = (data === null || data === void 0 ? void 0 : (ref1 = data.add_on_data) === null || ref1 === void 0 ? void 0 : ref1[3]) || {};
    var matches = (0,use_media_query/* useMediaQuery */.a)("(max-width: 768px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        component: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            sx: function(theme) {
                return (0,_define_property/* default */.Z)({
                    margin: "70px 0 20px"
                }, theme.fn.smallerThan("md"), {
                    margin: "30px 5px"
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "#",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                        order: 2,
                        size: "h2",
                        align: "center",
                        w: "100#",
                        sx: function(theme) {
                            return {
                                transition: "0.3s",
                                color: theme.colors.second[3],
                                "&:hover": {
                                    color: theme.colors.second[3]
                                }
                            };
                        },
                        children: (0,sanitizeDOMData/* default */.Z)(matches ? slogan2 === null || slogan2 === void 0 ? void 0 : slogan2.content : slogan === null || slogan === void 0 ? void 0 : slogan.content)
                    })
                })
            })
        })
    });
}
/* harmony default export */ var components_Slogan = (Slogan);
{
/* <Box
  sx={(theme) => ({
    transition: "0.3s",
    margin: "70px 0 20px",
    [theme.fn.smallerThan("md")]: {
      margin: "30px 5px",
    },
  })}
>
  <Link href="#" passHref>
    <a>
      <Title align="center">{sanitizeDOMData(slogan2?.content)}</Title>
      <Title align="center">{sanitizeDOMData(slogan3?.content)}</Title>
    </a>
  </Link>
</Box>; */ }
// EXTERNAL MODULE: ./common/components/BestSellers.js + 2 modules
var BestSellers = __webpack_require__(15556);
// EXTERNAL MODULE: ./apis/queryFunctions/menu.js
var queryFunctions_menu = __webpack_require__(54522);
// EXTERNAL MODULE: ./common/components/PageContainer.js
var PageContainer = __webpack_require__(41291);
// EXTERNAL MODULE: ./common/components/index.js + 3 modules
var components = __webpack_require__(93241);
;// CONCATENATED MODULE: ./pages/index.page.js

// import { useFetchCategories } from "@/apis/queryFunctions/categoryFunctions";



// import BestSellers from "@/common/components/BestSellers";














var __N_SSG = true;
function Home(param) {
    var seo = param.seo;
    var getCollectionHref = function getCollectionHref(maDanhMuc) {
        if (!menu || menu.length === 0) return "";
        var item = menu.find(function(el) {
            return el.ma_danh_muc === maDanhMuc;
        });
        if (!item) return "";
        return item.href;
    };
    // console.log(111111,seo)
    var ref = (0,categoryFunctions/* useFetchCategories */.rj)(), allCategories = ref.data;
    var highlights = (0,queryFunctions_menu/* useMenu */.H)(allCategories).highlights;
    var locale = (0,router.useRouter)().locale;
    var ref1 = (0,ecompagesFunctions/* useFetchEcompage */.VM)("trang-gioi-thieu-cafe", locale), detail = ref1.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        component: "div",
        pb: "lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultSEO/* default */.Z, {
                seo: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Slogan, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HomeAbout, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeLiked, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePromotion, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                fluid: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    sx: {
                        zIndex: 2
                    },
                    children: Boolean(detail) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContainer/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* WhyChooseHome */.Gm, {
                            item: detail === null || detail === void 0 ? void 0 : detail.add_on_data_2,
                            isHomeScreen: true
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeNews, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6530,2278,9072,9812,3241,9774,2888,179], function() { return __webpack_exec__(43916); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);